// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1831) return "static/chunks/1831-196f69e6a6994a69.js";
	if (chunkId === 3953) return "static/chunks/3953-fa09fcd644ce3a7b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8797 ? "af011179" : chunkId) + "." + {"5369":"4a471ed05d641813","5711":"848cbb85685646be","6733":"9d60118102e83cc6","7916":"326de97aa487c052","8797":"2a23c8d366752564"}[chunkId] + ".js";
};